<template>
  <select>
    <slot></slot>
  </select>
</template>
<script>
export default {
  props: ["options", "value", "search", "isAppType"],
  mounted: function() {
    function select2OptionFormat(option) {
      var originalOption = option.element;
      if ($(originalOption).data("html")) {
        return $(originalOption).data("html");
      }
      return option.text;
    }
    var vm = this;
    $(this.$el)
      // init select2
      .select2({
        data: this.options,
        dir: "rtl",
        minimumResultsForSearch:
          typeof this.search != "undefined" ? this.search : -1,
        formatResult: select2OptionFormat,
        formatSelection: select2OptionFormat,
        escapeMarkup: function(m) {
          return m;
        }
      })
      .val(this.value)
      .trigger("change")
      // emit event on change.
      .on("change", function() {
        vm.$emit("input", this.value);
        // For on change appointment type/insurance
        if (vm.$props.isAppType) vm.$root.$emit("changeFeeByType");
      });
  },
  watch: {
    value: function(value) {
      // update value
      $(this.$el)
        .val(value)
        .trigger("change");
    },
    options: function(options) {
      // update options
      $(this.$el)
        .empty()
        .select2({ data: options });
    }
  },
  destroyed: function() {
    $(this.$el)
      .off()
      .select2("destroy");
  }
};
</script>
